import { getSmarticoHash } from '../adapters/user'
import { EnvConfig } from '../config/EnvConfig'
import { handlePlatformAction } from './handlePlatformAction'
import { isiOS } from './mobileAppFunctionality'
import { navigate } from 'gatsby'
import storageService from './../services/storageService'
import { waitForCondition } from '../helpers/promise'

export const smarticoURL = EnvConfig.GATSBY_SMARTICO_SCRIPT_URL
export const fallBackSmarticoURL = `${EnvConfig.SITE_URL}/smartico-fe-script.js`
const isInDev = EnvConfig.GATSBY_ENV === 'dev'
const labelKey = EnvConfig.GATSBY_SMARTICO_LABEL_KEY
const brandKey = EnvConfig.GATSBY_SMARTICO_BRAND_KEY

export const init = () => {
  window._smartico.init(labelKey, { brand_key: brandKey })
  window._smartico_allow_localhost = isInDev

  const initCallback = () => {
    window._smartico.off('init', initCallback)
    window.dispatchEvent(new CustomEvent('SMARTICO_LOADED'))
  }
  window._smartico.on('init', initCallback)

  window._smartico.on('gf_closing', () => {
    navigate(storageService.getValue('lastVisitedPage') ?? '/');
  });
}

export const logout = () => {
  window._smartico_user_hash = null
  window._smartico_user_id = null
  window._smartico_language = null
}

export const login = async (user) => {
  const smarticoHashId = await getSmarticoHash()
  window._smartico_user_hash = smarticoHashId.data.data
  window._smartico_user_id = user.id
  window._smartico_language = user.user_language.urlCode

  handlePlatformAction(
    () => window._smartico.setLoginEntry('APP'),
    () => window._smartico.setLoginEntry('MOBILE'),
    () => window._smartico.setLoginEntry('DESKTOP')
  )

  updatePushNotificationToken()
}

export const updatePushNotificationToken = (e) => {
  if (!window.fcm_token) window.fcm_token = e?.detail?.token

  const platformTypeId = isiOS() ? 6 : 7
  const token = e?.detail?.token || window.fcm_token

  if (!token) return

  window._smartico?.registerNativePushToken(
    token,
    platformTypeId,
    'com.kto.app'
  )
}

export const waitForSmartico = () => {
  const isSmarticoAvailable = () => window._smartico

  return waitForCondition(isSmarticoAvailable)
}
